import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { Link as FormLink } from '@components/form';
import { media } from '@theme/media';

export const Container = styled.div`
  border-top: 1px solid ${COLORS.BLACK};
  padding: 34px 0 17px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  min-height: 52px;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.01em;

  ${media.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  ${media.desktop} {
    grid-template-columns: 396px auto;
  }
`;

export const RightContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;

  ${media.mobile} {
    grid-template-columns: 1fr auto;
  }

  ${media.tablet} {
    grid-template-columns: 340px 1fr;
  }

  ${media.desktop} {
    grid-template-columns: 380px auto;
  }
`;

export const Link = styled(FormLink)`
  display: inline-block;
`;

export const ButtonContainer = styled.div`
  padding-bottom: 17px;

  button,
  a {
    white-space: nowrap;
  }
`;

export const Description = styled.div`
  ${media.desktop} {
    padding-right: 40px;
  }
`;
